import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './click-outside.directive';
import { DropdownDirective } from './dropdown/dropdown.directive';
import { LoadingDirective } from './loading/loading.directive';
import { AwesomeTooltipComponent } from './tooltip/tooltip.component';
import { AwesomeTooltipDirective } from './tooltip/tooltip.directive';

@NgModule({
    declarations: [
        AwesomeTooltipDirective,
        AwesomeTooltipComponent,
        ClickOutsideDirective,
        DropdownDirective,
        LoadingDirective,
    ],
    imports: [CommonModule, OverlayModule],
    exports: [
        AwesomeTooltipDirective,
        ClickOutsideDirective,
        DropdownDirective,
        LoadingDirective,
    ],
})
export class DirectivesModule {}
